module.exports = __webpack_public_path__ + "img/travel-sixt.b7c9f6a6.jpg";